import { Box, Grid, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DatePicker from '../../../components/datepicker/DatePicker'
import { tokens } from '../../../theme';
import { useSite } from '../../../components/siteselector/SiteContext';
import { useDate } from '../../../components/datepicker/DateContext';
import { useNavigate, useParams } from 'react-router-dom';
import mockData from '../../../mockdata/scatterPlotData.json'
import GetSiteRec from '../../../components/api/GetSiteRec';
import { ScatterPlot } from '../../../components/charts/default';
import LoginCookieAuth from '../../../components/api/LoginCookieAuth';
import Cookies from 'js-cookie';
import GetUser from '../../../components/api/GetUser';

function EnergyTempCurveScene() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [siteName, setSiteName] = useState("");
    const [, setSiteRec] = useState({});
    const { selectedSite } = useSite();
    const { selectedDate } = useDate();
    const { siteId } = useParams();
    const navigate = useNavigate();
    const [pageAcces, SetPageAcces] = useState(false)

    useEffect(() => {
        GetUser().then((response) => {
            const pageWhitelist = response.data["rows"][0].infSiteModules
            if (pageWhitelist.includes('ems/energytempcurve')) {
                SetPageAcces(true)
            } else {
                navigate('/projects')
            }
        });
        LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async (authResponse) => {
            if (authResponse) {
                if (siteId !== "undefined") {
                    GetSiteRec(siteId).then((response) => {
                        const responseVal = response.data["rows"][0]
                        setSiteRec(responseVal)
                        setSiteName(responseVal["navName"])
                    })
                }
                //scroll after navigating
                document.getElementById('content').scrollTo(0, 0)
            }
        })
    }, [navigate, siteId, siteName, selectedSite, selectedDate]);

    return (
        <>
            {
                pageAcces ? (
                    <Box m="18px" maxWidth="100%">
                        {/* TOP ROW - BUTTONS*/}
                        <Box display="grid" sx={{ p: "0 0 20px 0", display:'flex' }}>
                            <DatePicker />
                        </Box>

                        <Grid container gap={2} direction={{ xl: "row" }} wrap="nowrap" height='100%' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                            <Grid item xl={9}>
                                <Box height='800px'>
                                    <ScatterPlot data={mockData} />
                                </Box>
                            </Grid>
                            <Grid item xl={3}>
                                <Typography fontSize={20} fontWeight='bold' color={colors.greenAccent[500]} textAlign='left'>Doel</Typography>
                                <Typography fontSize={15} textAlign='left'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut aliquet at nunc vel pretium. Duis arcu odio, rhoncus et orci eget, laoreet fermentum quam. Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula. Donec ultrices ante magna, quis lacinia libero placerat vitae. Aliquam pretium velit enim, eu hendrerit turpis volutpat nec.</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                ) : (
                    null
                )
            }
        </>
    )
}

export default EnergyTempCurveScene;